import apiClient from '@/services/AccountClient'

const state = () => ({
  internalLinks: [],
  internalLinksLoaded: false
})

const getters = {
  internalLinkOptions: (state) => {
    return state.internalLinks.map(({ name, code }) => ({
      name,
      value: code
    }))
  },
  internalLinksLoaded: (state) => {
    return state.internalLinksLoaded
  }
}

const actions = {
  loadInternalLinks ({ commit }) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/internal-links'
    )
      .then(({ payload }) => {
        commit('setInternalLinks', payload)
        commit('setInternalLinksLoaded')
      })
  }
}

const mutations = {
  setInternalLinks (state, currencyList) {
    state.internalLinks = currencyList
  },
  setInternalLinksLoaded (state) {
    state.internalLinksLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
